import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { UserAttributeComponent } from './user-attribute.component';
import { ConfirmPopUpFinzyFlexComponent } from '../confirm-pop-up-finzy-flex/confirm-pop-up-finzy-flex.component';

@Injectable()
export class UserAttributeDeactivationGuard implements CanDeactivate<UserAttributeComponent> {
    private readonly matDialog: MatDialog;

    constructor(matDialog: MatDialog) {
        this.matDialog = matDialog;
    }

    canDeactivate(component: UserAttributeComponent): Observable<boolean> | boolean {
        if (component.shouldStopFromNavigatingAway()) {
            return this.matDialog.open(ConfirmPopUpFinzyFlexComponent, {
                data: {
                    title: 'Do you want to continue',
                    subTitle: 'Your preference set up is incomplete',
                    message: `Click on <strong> Set Up Now </strong> to continue setting up preferences. You can click on <strong> Set Up Later </strong> to set the preferences later.`,
                    positiveButtonText: 'Set Up Later',
                    negativeButtonText: 'Set Up Now'
                },
                width: '50%',
                minWidth: '320px',
                panelClass: "confirm-dialog-responsive"
            }).afterClosed();
        } else {
            return true;
        }
    }
}
